import React from 'react';

const AccountIcon = (props) => (
    <svg {...props} fill="currentColor" className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.5 45.5">
        <g>
            <path
                className="st0"
                d="M22.8,0C10.2,0,0,10.2,0,22.8s10.2,22.8,22.8,22.8c12.6,0,22.8-10.2,22.8-22.8S35.3,0,22.8,0z M22.8,6.8
		c4.2,0,7.5,3.4,7.5,7.5c0,4.2-3.4,7.5-7.5,7.5c-4.2,0-7.5-3.4-7.5-7.5C15.2,10.2,18.6,6.8,22.8,6.8z M22.8,39.6
		c-4.1,0-7.9-1.5-10.9-4c-0.7-0.6-1.1-1.5-1.1-2.4c0-4.2,3.4-7.6,7.6-7.6h8.8c4.2,0,7.6,3.4,7.6,7.6c0,0.9-0.4,1.8-1.1,2.4
		C30.7,38.1,26.9,39.6,22.8,39.6z"
            />
        </g>
    </svg>
);

export default AccountIcon;
